module.exports = __webpack_public_path__ + "img/knight.19a5e699.png";